export default __webpack_public_path__ + "static/media/BTP_Logo_1.ba215050.svg";